<template>
    <v-container fluid>
        <v-row class="ma-0">
            <v-col class="pa-0 pt-4">
                <show
                    :modelDef="modelDef"
                    :id="id"
                    no-buttons
                    topClass=""
                ></show>
            </v-col>
        </v-row>

        <v-row class="ma-0">
            <v-col class="pa-0 pt-4">
                <v-card class="flex pa-0 round-card background-2">
                    <v-card-title primary-title>
                        Dati simulati ad oggi
                    </v-card-title>
                    <v-data-table
                        :headers="headers"
                        :items="items"
                        class="elevation-1"
                        :search="search"
                        dense>
                        <template v-slot:top>
                            <v-text-field
                                v-model="search"
                                label="Cerca"
                                class="mx-4"
                            ></v-text-field>
                        </template>

                        <template v-slot:item.current_revenue="{item}">
                            {{item.current_revenue | currency}}
                        </template>

                        <template v-slot:item.last_revenue="{item}">
                            {{item.last_revenue | currency}}
                        </template>

                        <template v-slot:item.calc_target="{item}">
                            {{item.calc_target | currency}}
                        </template>

                        <template v-slot:item.increment="{item}">
                            <span v-if="parseFloat(item.increment).toFixed(0) > 0" class="success--text">
                                <span class="success--text">{{parseFloat(item.increment).toFixed(0) }} %</span>
                                <v-icon color="success">trending_up</v-icon>
                            </span>
                            <span v-else-if="parseFloat(item.increment).toFixed(0) == 0" class="success--text">
                                <v-icon color="info">trending_flat</v-icon>
                            </span>
                            <span v-else>
                                <span class="error--text">{{parseFloat(item.increment).toFixed(0) }} %</span>
                                <v-icon color="error">trending_down</v-icon>
                            </span>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>

    </v-container>
</template>

<script>
export default {
    name: 'simulate-mail-schedule',
    props: {
        id: Number,
        modelDef: String
    },
    data() {
        return {
            search: '',
            items: [],
            headers: [
                {text: 'Cod.', value: 'code'},
                {text: 'Ragione Sociale', value: 'business_name'},
                {text: 'Email', value: 'primary_email'},
                {text: 'Fatturato', value: 'current_revenue'},
                {text: 'Fatturato Precedente', value: 'last_revenue'},
                {text: 'Incremento %', value: 'increment'},
                {text: 'Obiettivo Calcolato', value: 'calc_target'},
            ]
        }
    },

    mounted() {
        this.axios.get('companiesmailsschedules/'+this.id+'/simulate').then(response => {
            this.items = response.data.companies

            this.$store.commit('endProgress')
        })
    }
}
</script>